/* ===== 排行榜 ===== */
export const rankingItems = [
  {
    rank: 1,
    title: '某顶流深夜密会神秘女子，酒店共处细节全曝光',
    heat: '987万',
    tag: '爆',
    time: '2小时前',
    trend: 'up',
    trendValue: '↑12',
  },
  {
    rank: 2,
    title: '知名导演被曝片场霸凌，多位一线演员实名指控',
    heat: '856万',
    tag: '热',
    time: '3小时前',
    trend: 'up',
    trendValue: '↑8',
  },
  {
    rank: 3,
    title: '豪门婚变再升级！财产分割内幕流出引全网震动',
    heat: '742万',
    tag: '热',
    time: '5小时前',
    trend: 'up',
    trendValue: '↑23',
  },
  {
    rank: 4,
    title: '当红小生学历造假？母校老师独家回应再掀波澜',
    heat: '689万',
    tag: '新',
    time: '1小时前',
    trend: 'up',
    trendValue: '↑31',
  },
  {
    rank: 5,
    title: '网红主播偷税被重罚数千万，直播平台账号全封',
    heat: '623万',
    tag: '热',
    time: '6小时前',
    trend: 'down',
    trendValue: '↓5',
  },
  {
    rank: 6,
    title: '某女星整容前后惊人对比，圈内好友意外说漏嘴',
    heat: '541万',
    tag: '新',
    time: '30分钟前',
    trend: 'up',
    trendValue: '↑47',
  },
  {
    rank: 7,
    title: '知名企业家身世之谜再起，神秘知情人士提供关键线索',
    heat: '498万',
    tag: '热',
    time: '4小时前',
    trend: 'up',
    trendValue: '↑19',
  },
];

/* ===== 特色卡片 ===== */
export const featureItems = [
  {
    icon: 'ri-fire-line',
    title: '实时热度追踪',
    description: '全网黑料PK热度数据每5分钟自动刷新，实时捕捉每一个八卦话题的爆发拐点，不错过任何一个吃瓜窗口期。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '深度爆料挖掘',
    description: '独家深扒团队持续跟进各大争议事件，为你还原事件全貌，梳理时间线与关键人物关系图谱。',
  },
  {
    icon: 'ri-group-line',
    title: '千万吃瓜社区',
    description: '数百万吃瓜群众在线讨论，投票PK、观点碰撞，让每一个黑料都在最热闹的氛围中发酵升温。',
  },
];

/* ===== 图文卡片 ===== */
export const cardItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20paparazzi%20night%20scene%20with%20blurred%20figures%20entering%20luxury%20hotel%2C%20mysterious%20atmosphere%2C%20warm%20street%20light%2C%20cinematic%20style%2C%20dark%20tones%20with%20red%20accents%2C%20editorial%20photography%2C%20no%20faces%20visible&width=800&height=500&seq=card-01&orientation=landscape',
    title: '娱乐圈年度最大瓜：顶流明星私生活大起底',
    description: '多方线人交叉验证，深夜密会事件背后的资本博弈与情感纠葛浮出水面，涉事多方尚未回应。',
    tag: '深度深扒',
    time: '7月30日',
    heat: '1287万热度',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20courtroom%20scene%20with%20documents%20and%20legal%20papers%2C%20tense%20atmosphere%2C%20warm%20golden%20lighting%2C%20cinematic%20composition%2C%20editorial%20style%2C%20no%20people%20faces%2C%20dark%20wood%20furniture&width=800&height=500&seq=card-02&orientation=landscape',
    title: '豪门争产案最新进展：百亿家产分割方案流出',
    description: '家族内部会议录音曝光，三房子女各执一词，这场持续三年的争产大戏终将迎来结局？',
    tag: '持续追踪',
    time: '7月29日',
    heat: '1103万热度',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20smartphone%20screen%20showing%20social%20media%20feed%20with%20breaking%20news%2C%20dark%20background%20with%20warm%20glow%2C%20tense%20digital%20atmosphere%2C%20editorial%20photography%2C%20no%20identifiable%20content&width=800&height=500&seq=card-03&orientation=landscape',
    title: '网红圈大地震：头部主播涉嫌数据造假被调查',
    description: '多平台联合清查行动已经开始，部分头部账号异常关闭引发猜测，粉丝群体反应激烈。',
    tag: '最新爆料',
    time: '7月30日',
    heat: '965万热度',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20leaked%20documents%20on%20a%20dark%20desk%20with%20dramatic%20lighting%2C%20cinematic%20noir%20style%2C%20warm%20amber%20accents%2C%20suspenseful%20atmosphere%2C%20editorial%20photography&width=800&height=500&seq=card-04&orientation=landscape',
    title: '影视圈潜规则内幕：某制片人聊天记录遭曝光',
    description: '涉及多位知名艺人，行业内幕令人瞠目，相关协会已发声明表示将严肃调查。',
    tag: '独家爆料',
    time: '7月28日',
    heat: '892万热度',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20scene%20of%20social%20media%20icons%20floating%20in%20dramatic%20warm%20light%2C%20gossip%20and%20news%20theme%2C%20editorial%20photography%20style%2C%20rich%20contrast%2C%20mysterious%20ambiance&width=800&height=500&seq=card-05&orientation=landscape',
    title: '分手风波升级：明星情侣互发律师函对簿公堂',
    description: '从恩爱CP到对簿公堂仅用三个月，双方的声明措辞激烈，网友站队已经白热化。',
    tag: '热点追踪',
    time: '7月27日',
    heat: '756万热度',
  },
];

/* ===== 读者评论 ===== */
export const commentItems = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20warm%20toned%20abstract%20circle%20with%20gradient%2C%20simple%20design%2C%20no%20face&width=120&height=120&seq=avatar-01&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '28分钟前',
    content: '这个瓜我吃了三天了，越吃越有料！资本的力量真的可怕，希望这次能有个公道的结果，不要又是雷声大雨点小。',
    likes: 2831,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20warm%20toned%20abstract%20circle%20with%20gradient%2C%20simple%20design%2C%20no%20face%2C%20different%20color&width=120&height=120&seq=avatar-02&orientation=squarish',
    name: '娱乐圈纪检委',
    time: '1小时前',
    content: '我就说这事不简单吧！之前的细节现在全对上了，果然是有人在背后操纵舆论，建议深扒背后的资本链条。',
    likes: 1956,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20warm%20toned%20abstract%20circle%20with%20gradient%2C%20simple%20design%2C%20no%20face%2C%20different%20color%20scheme&width=120&height=120&seq=avatar-03&orientation=squarish',
    name: '匿名吃瓜群众',
    time: '2小时前',
    content: '刚看完完整时间线梳理，只能说贵圈真乱。不过每日黑料的整理能力确实强，比我自己到处翻方便太多了。',
    likes: 1472,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20warm%20toned%20abstract%20circle%20with%20gradient%2C%20simple%20design%2C%20no%20face%2C%20different%20warm%20color&width=120&height=120&seq=avatar-04&orientation=squarish',
    name: '真相挖掘机',
    time: '3小时前',
    content: '作为一个老吃瓜人，我建议大家理性吃瓜，等待官方回应。但说实话，这次爆料的证据链确实很完整，很难洗。',
    likes: 2103,
  },
];

/* ===== FAQ ===== */
export const faqItems = [
  {
    question: '每日黑料的爆料信息来源可靠吗？',
    answer: '我们采用多重交叉验证机制，所有上榜的黑料信息均经过编辑团队核实整理的公开资料、社交媒体信息及多方信源交叉比对。同时，每条信息均标注来源与核实状态，读者可自行判断可信度。对于未经证实的信息，我们会在标题及内容中明确标注"待核实"。',
  },
  {
    question: '黑料排行榜的热度数据是如何计算的？',
    answer: '热度值综合计算了话题的搜索量增幅、社交媒体讨论量、相关文章阅读量、用户互动（点赞/评论/分享）以及话题持续时长五个维度，每5分钟自动更新一次。热度算法经过持续优化，确保能真实反映话题的公共关注度。',
  },
  {
    question: '我可以投稿爆料吗？如何操作？',
    answer: '当然可以！我们非常欢迎知情人士提供线索和爆料。你可以在页面底部的"联系我们"区域找到投稿入口，提交相关信息。所有投稿均严格保密，爆料人身份信息不会以任何形式公开。我们会对每一条投稿进行独立核实。',
  },
  {
    question: '被曝光的内容涉及不实信息怎么办？',
    answer: '我们设有完善的申诉与更正机制。如你认为榜单中的信息存在事实错误，可通过页面底部的联系方式提交申诉，我们的编辑团队会在24小时内核实处理。经核实确实有误的内容将立即更正或下架，并在原位置发布更正说明。',
  },
  {
    question: '每日黑料和一般的八卦网站有什么区别？',
    answer: '不同于传统的娱乐八卦媒体，我们更注重信息的结构化呈现与数据化追踪。我们不做主观评判，而是通过热度数据、时间线梳理、人物关系图谱等方式帮助读者全景式理解事件。同时，我们建立了严格的社区讨论规范，鼓励理性吃瓜、拒绝人身攻击。',
  },
];

/* ===== 焦点专题 ===== */
export const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20scene%20of%20social%20media%20breaking%20news%2C%20dark%20red%20and%20gold%20color%20palette%2C%20suspenseful%20mood%2C%20editorial%20style%2C%20no%20text%2C%20abstract%20news%20theme&width=900&height=500&seq=focus-01&orientation=landscape',
    title: '2024上半年十大黑料回顾',
    description: '从豪门婚变到娱乐圈大地震，这半年我们吃了多少大瓜？',
    tag: '半年盘点',
    count: '15篇深度',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20dark%20themed%20timeline%20visualization%20with%20warm%20glowing%20nodes%2C%20mysterious%20atmosphere%2C%20editorial%20photography%20style%2C%20no%20text&width=900&height=500&seq=focus-02&orientation=landscape',
    title: '某顶流塌房全事件时间线',
    description: '从第一波爆料到全面崩塌，48小时内发生了什么？',
    tag: '事件复盘',
    count: '22篇深扒',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20network%20of%20connections%20and%20relationships%20in%20warm%20golden%20and%20dark%20tones%2C%20mysterious%20corporate%20theme%2C%20editorial%20photography&width=900&height=500&seq=focus-03&orientation=landscape',
    title: '娱乐圈资本版图大起底',
    description: '谁是谁的金主？一张图看懂娱乐圈背后的资本网络。',
    tag: '深度分析',
    count: '18篇专题',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20split%20screen%20composition%20with%20warm%20and%20dark%20contrast%2C%20before%20and%20after%20transformation%20theme%2C%20editorial%20photography%2C%20no%20faces&width=900&height=500&seq=focus-04&orientation=landscape',
    title: '那些年我们追过的反转大戏',
    description: '你以为的真相也许只是开始，盘点近年最精彩的反转事件。',
    tag: '经典回顾',
    count: '12篇合集',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20leaked%20information%20visual%20theme%20with%20dramatic%20warm%20lighting%2C%20secret%20files%20aesthetic%2C%20editorial%20photography%20style&width=900&height=500&seq=focus-05&orientation=landscape',
    title: '即将曝光：下半年最大瓜预告',
    description: '多方线人透露，下半年还有几个重磅猛料正在核实中。',
    tag: '独家预告',
    count: '持续更新',
  },
];

/* ===== 主题索引 ===== */
export const indexItems = [
  { title: '娱乐圈八卦', count: '1286篇', icon: 'ri-movie-2-line' },
  { title: '网红圈爆料', count: '953篇', icon: 'ri-live-line' },
  { title: '豪门恩怨', count: '674篇', icon: 'ri-building-2-line' },
  { title: '政商圈内幕', count: '512篇', icon: 'ri-government-line' },
  { title: '科技圈争议', count: '438篇', icon: 'ri-smartphone-line' },
  { title: '体育圈黑幕', count: '391篇', icon: 'ri-basketball-line' },
  { title: '学术圈造假', count: '267篇', icon: 'ri-book-open-line' },
];

/* ===== 话题标签 ===== */
export const topicItems = [
  { name: '#顶流塌房', heat: '1287万', count: '365条' },
  { name: '#豪门争产', heat: '1103万', count: '289条' },
  { name: '#网红翻车', heat: '965万', count: '412条' },
  { name: '#明星离婚', heat: '892万', count: '198条' },
  { name: '#学历造假', heat: '756万', count: '156条' },
  { name: '#偷税漏税', heat: '689万', count: '203条' },
  { name: '#潜规则曝光', heat: '623万', count: '178条' },
  { name: '#整容争议', heat: '541万', count: '234条' },
  { name: '#数据造假', heat: '498万', count: '145条' },
  { name: '#私生子传闻', heat: '432万', count: '98条' },
];

/* ===== 关于 ===== */
export const aboutData = {
  description: '每日黑料成立于2023年，是国内领先的黑料八卦聚合与吃瓜热度追踪平台。我们通过自主研发的热度算法，实时追踪全网最具争议的爆料话题，为超过500万吃瓜群众提供最及时、最全面的黑料资讯。平台秉持"理性吃瓜、拒绝造谣"的核心理念，所有信息均经过多重交叉验证，致力于在信息爆炸的时代为读者提供可信赖的内容导航。',
};

/* ===== APP ===== */
export const appData = {
  title: '每日黑料 App — 吃瓜更及时',
  description: '随时随地掌握全网最新黑料动态，推送比网页快3分钟，离线也能浏览已加载内容。更有专属"暗黑模式"保护你的吃瓜隐私。',
  features: ['实时推送快人一步', '暗黑模式护眼防窥', '离线也能看已加载内容', '一键分享到社交平台'],
};

/* ===== 更新动态 ===== */
export const updateItems = [
  {
    date: '2024.07.30',
    title: '系统升级完成',
    description: '热度算法V3.0上线，话题识别精度提升40%，现在能更准确地捕捉爆发性话题。',
  },
  {
    date: '2024.07.29',
    title: '新增辟谣专区',
    description: '针对近期多起反转事件，上线官方辟谣信息聚合专区，帮助读者辨别真假黑料。',
  },
  {
    date: '2024.07.28',
    title: '投稿系统优化',
    description: '爆料投稿入口改版，支持图片与文件上传，并对投稿人的隐私保护进行了全面加固。',
  },
  {
    date: '2024.07.26',
    title: '人物关系图谱上线',
    description: '针对复杂事件推出可视化人物关系图，一键看清事件中各方势力与利益链条。',
  },
  {
    date: '2024.07.24',
    title: '社区讨论规范更新',
    description: '发布新版社区公约，进一步加强理性吃瓜氛围，严厉打击人身攻击与造谣行为。',
  },
  {
    date: '2024.07.22',
    title: '移动端体验优化',
    description: '针对iOS和Android端进行了全面适配，加载速度提升60%，夜间模式正式上线。',
  },
  {
    date: '2024.07.20',
    title: '合作媒体扩容',
    description: '新增5家合作媒体信源，进一步丰富了信息采集渠道，提升内容多样性与覆盖面。',
  },
  {
    date: '2024.07.18',
    title: '举报处理公示上线',
    description: '为增加透明度，所有举报处理结果将在处理完成后48小时内公示，接受读者监督。',
  },
  {
    date: '2024.07.15',
    title: '每日黑料数据年报发布',
    description: '2024上半年共收录黑料话题超过8000条，累计产生42亿次浏览，读者互动超3亿次。',
  },
];

/* ===== 媒体卡片 ===== */
export const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20dark%20studio%20set%20with%20warm%20spotlight%2C%20podcast%20or%20news%20show%20vibe%2C%20editorial%20photography%2C%20mysterious%20atmosphere%2C%20no%20people&width=700&height=450&seq=media-01&orientation=landscape',
    title: '【深度】某顶流塌房始末：48小时全记录',
    duration: '32:18',
    views: '128万次播放',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20visualization%20of%20data%20connections%20and%20networks%20in%20dark%20warm%20tones%2C%20investigative%20theme%2C%20editorial%20photography&width=700&height=450&seq=media-02&orientation=landscape',
    title: '【复盘】豪门争产案：三年恩怨完整解读',
    duration: '45:02',
    views: '96万次播放',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20dark%20composition%20with%20social%20media%20icons%20and%20breaking%20news%20theme%2C%20warm%20lighting%2C%20editorial%20photography&width=700&height=450&seq=media-03&orientation=landscape',
    title: '【快评】网红偷税事件：直播行业洗牌加速',
    duration: '18:45',
    views: '87万次播放',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20dark%20interview%20setting%20with%20warm%20ambient%20light%2C%20documentary%20style%2C%20editorial%20photography%2C%20no%20people&width=700&height=450&seq=media-04&orientation=landscape',
    title: '【独家】知情人士专访：爆料背后的故事',
    duration: '52:10',
    views: '203万次播放',
  },
];